/**
 * One canonical date/time formatter for Live-session UIs so the listing,
 * host header, exports, and any future placement render identically.
 *
 * Output: "20 May 2026, 3:45 PM" — day, abbreviated month, year, 12-hour
 * clock with AM/PM. Uses `en-GB` for the date part (day-first) and
 * `en-US` for the time part (am/pm) so we get the day-first ordering
 * trainers expect without dragging in a full i18n library.
 */

const DATE_OPTS = { day: '2-digit', month: 'short', year: 'numeric' };
const TIME_OPTS = { hour: 'numeric', minute: '2-digit', hour12: true };

export function formatSessionDateTime(iso) {
  if (!iso) return '';
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  if (Number.isNaN(d.getTime())) return '';
  const date = new Intl.DateTimeFormat('en-GB', DATE_OPTS).format(d);
  const time = new Intl.DateTimeFormat('en-US', TIME_OPTS).format(d);
  return `${date}, ${time}`;
}

/**
 * Returns `{ label, iso }` for the most relevant timestamp on a Live
 * session — `started_at` if the host actually pressed Start, otherwise
 * `created_at` for lobby-only sessions. Used by both the listing
 * subtitle and the host page header.
 */
export function bestSessionTimestamp(session) {
  if (!session) return { label: '', iso: null };
  if (session.started_at) return { label: 'Started', iso: session.started_at };
  return { label: 'Created', iso: session.created_at || null };
}
